<script setup lang="ts">
import { useI18n } from 'vue-i18n'

defineProps<{ status: '403' | '404'; titleKey: string; subtitleKey: string }>()
const { t } = useI18n()
</script>

<template>
  <section class="page-panel">
    <a-result :status="status" :title="t(titleKey)" :subtitle="t(subtitleKey)" />
  </section>
</template>
